import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1673231353890'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='2665'
    >
        <path d='M192 396.8L272 320l240 236.16L752 320l80 76.8L512 704z' fill='currentColor' p-id='2666'></path>
    </svg>
)

export const DownOutlinedIcon = props => <Icon component={SVG} {...props} />
